import './table.less';

// import WithCoreProps from '../../../hocs/withCoreProps';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { PrimaryTable } from './tableModules/primary';
import { WithLevelsTable } from './tableModules';
import { TableAppearance, Row, Total, ColType, HeadersWithDescription } from './types';
import { TableRowAppearances } from '../tableRow/types';
import { WithoutHeaderTable } from './tableModules/withoutHeader';
import { WithAccordionTable } from './tableModules/withAccordion';
import { LoggerHelper, WithCoreProps } from 'ff-shared-components-core';
import { WithAccordionGreyTable } from './tableModules/withAccordionGrey';
import { InputsTable } from './tableModules/inputsTable';

// [COMPONENT USAGE]

//Primary table example(this table can have a checkbox or an image as a prefix and  details button as a suffix) :
// const columnsWidth = [ColType.extraBig, ColType.normal, ColType.extraBig, ColType.currency];
// Column types :  normal for dates , currency for amounts , big for small descriptions , extra big for extensive descriptions

// <Table
// 	columnsWidth={columnsWidth}
// 	appearance={TableAppearance.primary}
// 	withImage
// 	withSuffix
// 	pathToRedirect="/example2"
// 	headings={headings}
// 	rows={rows}
// ></Table>;

//Table with 2 levels (withTotals)
/* <Table
	appearance={TableAppearance.withLevels}
	withSuffix
	pathToRedirect="/example2"
	headings={headings}
	rows={rows2} check the Row interface for better understanding
	totals={totals}
></Table>;*/

export interface TableProps {
	appearance: TableAppearance;
	/**sets the header values */
	headers?: string[];
	/**sets the headers with description values on withAccordionGrey table*/
	headersWithDescription?: HeadersWithDescription[];
	/**sets the row values */
	rows?: Row[];
	/**Through this prop u can control the width of each individual column of the table*/
	columnsWidth?: ColType[];
	/**Sets a checkbox prefix*/
	withCheckbox?: boolean;
	/**Sets a icon column at the end of table*/
	withDownloadableSuffix?: boolean;
	/**Sets a multiple checkbox prefix*/
	hasMultipleChecked?: boolean;
	/**Sets a suffix for the table row */
	withSuffix?: boolean;
	/**Sets a empty column at the end of table*/
	withEmptySpaceSuffix?: boolean;
	/**Sets an image prefix for the table row */
	withImage?: boolean;
	/**set a base path to redirect on more details click */
	pathToRedirect?: string;
	/**Set the checkbox check*/
	isCheckboxChecked?: boolean;
	/**Set the row appearance */
	rowAppearance?: TableRowAppearances;
	/**Set totals*/
	totals?: Total[];
	/**With Accordion Grey totals */
	greyTotals?: Row;
	/**Sets a message in case there is no data to show */
	noDataMessage?: string;
	/**Sets an error message in case something went wrong*/
	errorMessage?: string;
	/**flag for error message */
	hasError?: boolean;
	/**defines max rows selected at once to be 3 */
	lockAtThreeSelectedRows?: boolean;
	/**Sets a suffix name to be shown on mobile */
	suffixName?: string;
	/** serves the purpose of catching the current selected row */
	onChange?: (items: Row[]) => void;
	/** serves the purpose of catching the current selected row */
	onRowsChange?: (items: Row[]) => void;
	/**Sets an event to be handled on details click */
	onDetailsClick?: (row?: any) => void;
}

type Props = TableProps & RouteComponentProps;

class TableComponent extends React.PureComponent<Props> {
	public render(): React.ReactNode {
		const { appearance } = this.props;
		return (
			<>
				{appearance === TableAppearance.primary && (
					<PrimaryTable {...this.props} onChange={this.handleChange}></PrimaryTable>
				)}

				{appearance === TableAppearance.withoutHeader && (
					<WithoutHeaderTable {...this.props}></WithoutHeaderTable>
				)}

				{appearance === TableAppearance.withLevels && <WithLevelsTable {...this.props}></WithLevelsTable>}

				{appearance === TableAppearance.withAccordion && (
					<WithAccordionTable {...this.props}></WithAccordionTable>
				)}

				{appearance === TableAppearance.withAccordionGrey && (
					<WithAccordionGreyTable {...this.props}></WithAccordionGreyTable>
				)}

				{appearance === TableAppearance.withInputs && (
					<InputsTable {...this.props} onRowsChange={this.handleRowsChange}></InputsTable>
				)}
			</>
		);
	}

	private readonly handleChange = (rows: Row[]): void => {
		const { onChange } = this.props;
		onChange && onChange(rows);
	};

	private readonly handleRowsChange = (rows: Row[]): void => {
		const { onRowsChange } = this.props;
		onRowsChange && onRowsChange(rows);
	};
}

export const Table = WithCoreProps<TableProps>(withRouter(TableComponent));
